import { http } from '@/axios/instance/http';
import { useTokenInterceptors } from '@/axios/interceptors';

export const setupAxiosInterceptors = () => {
  useTokenInterceptors(http);
};
